export const paymentMethodEnum = {
  creditCard: "Credit Card",
  wireTransfer: "Wire Transfer",
  check: "Check",
  prepaid: "Prepaid",
  sponsor: "Sponsor",
  noCharge: "No Charge",
} as const;

export const statusEnum = {
  pending: "Unpaid",
  completed: "Paid",
  paidSPR: "Paid SPR",
  unpaidSPR: "Unpaid SPR",
  paidSPK: "Paid SPK",
  unpaidSPK: "Unpaid SPK",
  partial: "Partial",
} as const;

export const regularStatusEnum = Object.fromEntries(
  Object.entries(statusEnum).filter(([key]) => !/spr|spk/i.test(key)),
) as Record<
  keyof typeof statusEnum,
  (typeof statusEnum)[keyof typeof statusEnum]
>;

export const STAFF_OVERRIDE_STATUS = "staffOverride";

export const paymentStatusEnum = {
  pending: "pending",
  completed: "completed",
  failed: "failed",
  refunded: "refunded",
  paidSPR: "paidSPR",
  unpaidSPR: "unpaidSPR",
  paidSPK: "paidSPK",
  unpaidSPK: "unpaidSPK",
  partial: "partial",
  staffOverride: STAFF_OVERRIDE_STATUS,
} as const;

export const attendeesStatusEnum = {
  attending: "Attending",
  cancelled: "Cancelled",
} as const;

export const attendeesTypeEnum = {
  regular: "Member",
  regularSpeaker: "Member Speaker",
  sponsor: "Sponsor",
  guest: "Guest",
  speaker: "Speaker",
  invited_guest: "Invited Guest",
  staff: "Staff",
} as const;

export type PaymentMethod = keyof typeof paymentMethodEnum;
export type StatusType = keyof typeof statusEnum;
export type RegularStatusType = keyof typeof regularStatusEnum;
export type PaymentStatus = keyof typeof paymentStatusEnum;
export type AttendeesStatus = keyof typeof attendeesStatusEnum;
export type AttendeeType = keyof typeof attendeesTypeEnum;

export const invoiceAddressTypeEnum = {
  billing: "Billing",
  firm: "Firm's",
} as const;

export type InvoiceAddressType = keyof typeof invoiceAddressTypeEnum;
